'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaBook = function FaBook(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm38.1 10.7q0.9 1.2 0.4 2.9l-6.1 20.2q-0.5 1.4-1.8 2.4t-2.7 0.9h-20.6q-1.7 0-3.3-1.2t-2.2-2.9q-0.6-1.5-0.1-2.8 0-0.1 0.1-0.6t0.1-0.9q0-0.1-0.1-0.4t-0.1-0.5q0.1-0.2 0.2-0.4t0.4-0.6 0.4-0.5q0.5-0.8 1-2t0.6-2.1q0.1-0.2 0-0.6t0-0.7q0.1-0.2 0.4-0.6t0.4-0.5q0.5-0.8 0.9-2.1t0.6-2q0-0.2-0.1-0.7t0-0.6q0.1-0.3 0.5-0.7t0.5-0.5q0.4-0.6 1-1.9t0.6-2.1q0-0.2-0.1-0.6t0-0.6q0-0.2 0.2-0.4t0.4-0.5 0.4-0.5q0.1-0.2 0.3-0.6t0.4-0.8 0.3-0.8 0.5-0.7 0.5-0.6 0.9-0.2 1 0.1l0 0.1q0.8-0.2 1.1-0.2h17q1.7 0 2.6 1.2t0.4 2.9l-6.2 20.2q-0.8 2.7-1.6 3.5t-2.8 0.7h-19.4q-0.6 0-0.9 0.4-0.2 0.3 0 0.9 0.5 1.6 3.2 1.6h20.6q0.7 0 1.3-0.4t0.8-0.9l6.7-22q0.1-0.5 0.1-1.3 0.8 0.3 1.3 1z m-23.8 0q-0.1 0.3 0.1 0.5t0.4 0.2h13.6q0.3 0 0.6-0.2t0.3-0.5l0.5-1.4q0.1-0.3 0-0.5t-0.5-0.2h-13.6q-0.2 0-0.5 0.2t-0.4 0.5z m-1.8 5.7q-0.1 0.3 0 0.5t0.5 0.2h13.5q0.3 0 0.6-0.2t0.4-0.5l0.5-1.4q0-0.3-0.1-0.5t-0.4-0.2h-13.6q-0.3 0-0.6 0.2t-0.4 0.5z' })
        )
    );
};

exports.default = FaBook;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/book.js
// module id = 1388
// module chunks = 0